import { LayoutItem } from 'api/models';
import { RecoilState, atom } from 'recoil';

export const dragState: RecoilState<LayoutItem | undefined> = atom<
  LayoutItem | undefined
>({
  key: 'draggedLayoutItem',
  default: undefined,
});
